document.addEventListener("DOMContentLoaded", function () {
  const serviceOptions = document.querySelectorAll('.service-option');
  const hiddenInput = document.getElementById('service_selected');

  serviceOptions.forEach(option => {
    option.addEventListener('click', () => {
      // Toggle active class
      option.classList.toggle('active');

      // Collect all selected values
      const selectedValues = Array.from(serviceOptions)
        .filter(opt => opt.classList.contains('active'))
        .map(opt => opt.dataset.value);

      // Update hidden input with comma-separated values
      hiddenInput.value = selectedValues.join(', ');
    });
  });

  // ✅ PHONE VALIDATION LOGIC
  const phoneInput = document.getElementById('phoneInput');
  const phoneError = document.getElementById('phone-error');

  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      // If user types any non-numeric character
      if (/[^0-9]/.test(this.value)) {
        phoneError.style.display = 'block';
        phoneError.textContent = 'Please enter numbers only.';
        this.value = this.value.replace(/[^0-9]/g, '');
      } else {
        phoneError.style.display = 'none';
      }
    });
  }

  // ✅ FORM SUBMISSION LOGIC
  document.getElementById("contact_form").addEventListener("submit", function (e) {
    e.preventDefault(); // stop normal form submission

    // Phone validation before submission
    if (phoneInput && phoneInput.value.length !== 10) {
      phoneError.style.display = 'block';
      phoneError.textContent = 'Please enter a valid 10-digit phone number.';
      return; // stop submission
    } else {
      phoneError.style.display = 'none';
    }

    const form = e.target;
    const formData = new FormData(form);

    fetch(form.action, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result === "success") {
          const successMessage = document.getElementById("success-message");
          successMessage.style.display = "block";
          form.reset(); // clear form fields

          // Remove all active service options
          serviceOptions.forEach(opt => opt.classList.remove('active'));
          hiddenInput.value = '';

          setTimeout(() => {
            successMessage.style.display = "none";
          }, 5000);
        } else {
          alert("Something went wrong. Please try again.");
        }
      })
      .catch((error) => {
        alert("There was an error submitting the form.");
        console.error(error);
      });
  });
});
